export const isPrerenderBuild = () => {
  if (typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent || '')) {
    return true;
  }

  if (typeof window !== 'undefined' && (window.__PRERENDER_INJECTED || window.__SNAPSHOT__)) {
    return true;
  }

  return false;
};
